<div #mapContainer id="map" style="height: 280px; border-radius: 16px;"></div>
<p *ngIf="busy" role="status">Finding the address…</p>
<div *ngIf="error" role="status">
  <p class="text-danger">{{ error }}</p>
  <button type="button" class="btn btn-outline-primary" (click)="retry()">Try again</button>
</div>
